import axios from 'axios';
import { API_URL, config } from '../../../config/config';

// Service for Login admin
const signin = async (userData) => {
	const response = await axios.post(`${API_URL}/admin/LoginAdmin`, userData);
	if (response.data) {
		localStorage.setItem('token', JSON.stringify(response.data.token));
	}
	return response.data;
};

//Service for logout
const signOut = async () => {
	localStorage.clear();
};
// Service for getting cart data
// const getCartData = async () => {
// 	const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
// 	return cartData;
// };

const getCartData = async () => {
	const cartData = localStorage.getItem('CartData');
	return cartData ? JSON.parse(cartData) : [];
};

const addToCart = async (data) => {
	const product = data.product;

	const currentCart = JSON.parse(localStorage.getItem('CartData')) || [];
	currentCart.push(product);
	localStorage.setItem('CartData', JSON.stringify(currentCart));
	return currentCart;
};

const updateCart = async (data) => {
	const updatedCart = data.updatedCart;

	localStorage.setItem('CartData', JSON.stringify(updatedCart));
	return updatedCart;
};

const deleteCartData = async (ArticleId) => {
	const cart = JSON.parse(localStorage.getItem('CartData'));
	const updatedCartData = cart.filter((item) => item.ArticleCode !== ArticleId);
	localStorage.setItem('CartData', JSON.stringify(updatedCartData));
	return updatedCartData;
};

// Service for getting Admin
const getAdmin = async () => {
	const response = await axios.post(`${API_URL}/Admin/getadmin`, {}, config);
	return response.data;
};

// Service for getting User
const getUser = async () => {
	const response = await axios.post(`${API_URL}/User/getuser`, {}, config);
	return response;
};

// Service for getting all users

const Fetchuser = async (data, page) => {
	const response = await axios.post(`${API_URL}/Admin/FetchUser/?page=${page}`, data, config);

	return response.data;
};

// Service for changing user password
const changePassword = async (data) => {
	const response = await axios.post(`${API_URL}/user/changepassword`, data, config);
	return response;
};

const authService = {
	signin,
	signOut,
	getAdmin,
	getUser,
	changePassword,
	Fetchuser,
	getCartData,
	addToCart,
	updateCart,
	deleteCartData,
};

export default authService;
